import RetailAccountManager from '../../../components/retailAccounts/RetailAccountManager';
import { stepTitleClass, stepLeadClass } from './stepStyles';

type Props = {
  onLinked: () => Promise<void>;
  linking?: boolean;
  reactivation?: boolean;
  onAccountsChange?: () => void | Promise<void>;
};

const ConnectAlpacaStep = ({
  onLinked,
  linking = false,
  reactivation = false,
  onAccountsChange,
}: Props) => (
  <div>
    <h1 className={stepTitleClass}>
      {reactivation ? 'Activate an account' : 'Connect Alpaca to NovaQuantis'}
    </h1>
    <p className={stepLeadClass}>
      {reactivation
        ? 'Your onboarding is complete, but no trading account is active. Reactivate an existing account below, or link a new one.'
        : 'Enter the API key, secret, and endpoint from your Alpaca dashboard. We verify the credentials with Alpaca before saving them encrypted.'}
    </p>
    <RetailAccountManager
      variant="onboarding"
      onLinked={onLinked}
      onAccountsChange={onAccountsChange}
      connectSubmitLabel={
        reactivation ? 'Continue to Portfolio' : 'Connect & go to Portfolio'
      }
      connectSubmitting={linking}
    />
  </div>
);

export default ConnectAlpacaStep;
